import Login from '@views/mastery/signIn';
import SignUp from '@views/mastery/signUp';
import ForgotPassword from '@views/mastery/forgotPassword';
import Questionnaire from '@views/mastery/questionnaire';
import Profile from '@views/mastery/profile';
import History from '@views/mastery/history';
import Account from '@views/mastery/account';

export default [
  {
    path: '/sign-in',
    name: 'mastery#signIn',
    component: Login,
    meta: {
      fullscreen: true,
      public: true,
    },
  },
  {
    path: '/sign-up',
    name: 'mastery#signUp',
    component: SignUp,
    meta: {
      fullscreen: true,
      public: true,
    },
  },
  {
    path: '/forgot-password',
    name: 'mastery#forgotPassword',
    component: ForgotPassword,
    meta: {
      fullscreen: true,
      public: true,
    },
  },
  {
    path: '/questionnaire/:step?',
    name: 'mastery#questionnaire',
    component: Questionnaire,
    meta: {
      fullscreen: true,
      public: true,
      resourceOptional: true,
    },
  },
  {
    path: '/profile',
    name: 'mastery#profile',
    component: Profile,
    meta: {
      resourceOptional: true,
      secondaryRoute: true,
    },
  },
  {
    path: '/profile/account',
    name: 'mastery#account',
    component: Account,
    meta: {
      resourceOptional: true,
      secondaryRoute: true,
    },
  },
  {
    path: '/history',
    name: 'mastery#history',
    component: History,
    meta: {
      resourceOptional: true,
      secondaryRoute: true,
      previewer: true,
    },
  },
];
